import type { MediaValue, PictureValueType } from '../../data/sources';

export function getRatioFromPictureArray(
  pictures: PictureValueType[] | string | undefined
) {
  if (!pictures || typeof pictures === 'string' || !pictures.length) {
    return undefined;
  }

  const { width, height } =
    pictures.find(({ width, height }) => width > 0 && height > 0) || {};

  if (width && height) {
    return height / width;
  }

  return undefined;
}

function getRatioFromGalleryItems(
  items: MediaValue<string | PictureValueType[]>[] | undefined
): number | undefined {
  if (!items?.length) {
    return undefined;
  }

  for (const item of items) {
    const itemRatio = getRatioFromMediaValue(item);
    if (itemRatio !== undefined) {
      return itemRatio;
    }
  }

  return undefined;
}

export function getRatioFromMediaValue(
  media: MediaValue<string | PictureValueType[]> | undefined
): number | undefined {
  if (!media) {
    return undefined;
  }
  switch (media.type) {
    case 'image':
      return getRatioFromPictureArray(media.src);
    case 'video':
      return getRatioFromPictureArray(media.thumbnail);
    case 'gallery':
      return (
        getRatioFromGalleryItems(media.items) ??
        getRatioFromPictureArray(media.thumbnail)
      );
    case 'link':
      return getRatioFromPictureArray(media.src);
    default:
      return undefined;
  }
}
